/** @jsxRuntime classic */
/** @jsx jsx */
import React from 'react'
import { useSession } from 'next-auth/react'
import { ROUTE } from '/constants/pages'
import redirectToPage from '/lib/redirect'

import { jsx, Box, Text, Image, Button } from 'theme-ui'
import LightBoxDownloadIcon from '../../../public/static/icons/lightbox_download.svg' //leave as relative because is not importing it with absolute path
import styles from './styles'

import Lightbox from 'yet-another-react-lightbox'
import Download from 'yet-another-react-lightbox/plugins/download'
import Counter from 'yet-another-react-lightbox/plugins/counter'
import 'yet-another-react-lightbox/styles.css'
import 'yet-another-react-lightbox/plugins/counter.css'
import BrowserDownloadHelper from '/utils/BrowserDownloadHelper'

const MobileWallpapersPage = ({ ...props }) => {
  const { layout, locale } = props.pageProps
  const { router } = props
  const { data: session, status } = useSession()
  const loading = status === 'loading'

  const cmsMobileWallpapers = layout?.mobileWallpapers || []
  const defaultItemsToShow = 9

  const [isOpen, setIsOpen] = React.useState(false)
  const [activeIndex, setActiveIndex] = React.useState(0)
  const [numberOfitemsShown, setNumberOfItemsToShown] =
    React.useState(defaultItemsToShow)

  const handleOnClick = (index) => {
    setIsOpen(!isOpen)
    setActiveIndex(index)
  }

  const handleShowMore = () => {
    const cmsItemsLength = cmsMobileWallpapers.length
    numberOfitemsShown + defaultItemsToShow <= cmsItemsLength
      ? setNumberOfItemsToShown(numberOfitemsShown + defaultItemsToShow)
      : setNumberOfItemsToShown(cmsItemsLength)
  }

  const itemsToShow = React.useMemo(() => {
    return cmsMobileWallpapers
      .slice(0, numberOfitemsShown)
      .map((image, index) => (
        <Box key={index} sx={styles.imageWrapper}>
          <Image src={image} onClick={() => handleOnClick(index)} />
        </Box>
      ))
  }, [cmsMobileWallpapers, numberOfitemsShown])

  const handleDownload = (slide) => {
    if (!loading && !session)
      return redirectToPage(router, locale, ROUTE.LOGIN_PAGE)

    BrowserDownloadHelper(slide)
  }

  const showSeeMoreButton =
    cmsMobileWallpapers.length > 9 &&
    itemsToShow.length < cmsMobileWallpapers.length

  return (
    <Box sx={styles.container}>
      <Text sx={styles.title} as="h2">
        {layout?.mobilePageTitle}
      </Text>
      <Text sx={styles.subTitle} as="p">
        {layout?.mobilePageSubtitle}
      </Text>

      <Box sx={styles.contentWrapper}>{itemsToShow}</Box>

      {showSeeMoreButton && (
        <Box sx={styles.seeMoreButton}>
          <Button sx={styles.seeMoreButton} onClick={() => handleShowMore()}>
            {layout?.seeMoreButtonText}
          </Button>
        </Box>
      )}
      {!loading && isOpen && (
        <Lightbox
          sx={styles.lightbox(layout?.mobilePageTitle)}
          open={open}
          close={() => setIsOpen(!isOpen)}
          slides={cmsMobileWallpapers.map((image) => ({
            src: image,
          }))}
          plugins={[Download, Counter]}
          render={{
            iconDownload: () => <LightBoxDownloadIcon />,
          }}
          index={activeIndex}
          download={{
            download: ({ slide }) => handleDownload(slide),
          }}
        />
      )}
    </Box>
  )
}

export default MobileWallpapersPage
